import bg from './218692-NTRA-NHC-Background.png';
import ntra from './ntra.png';
import caesars from './racebook-no-cr-on-dark.png';
import hawthorne from './ClubHLogo.png';
import tvg from './tvg.png';
import globaltote from './global-tote_logo-negative.png'
import race_sportsbook from './race-sportsbook-on-dark.png'
import race_sportsbook_no_goblet from './race-sportsbook-no-goblet-on-dark.png'
import clsx from 'clsx';
import dayjs from 'dayjs';
import LeaderItem from './LeaderItem';
import styles from './Leaderboard.module.css';
import UserItem from './UserItem';
import { LeaderboardResponse, User } from './types';
import loadingGif from './loading.gif';

export default function Leaderboard({
  data,
}: {
  data: {
    users: User[],
    leaderboard?: LeaderboardResponse,
    loading: boolean;
    leaders: User[]
  };
}) {
  const { users = [], leaderboard, loading, leaders = [] } = data;
  const leaderboardPresent = leaderboard && leaderboard!.description

  return (
    <div className={styles.container} style={{ background: `center/cover url(${bg})`}}>
      {
        leaderboard ? (
          <div className={styles.content}>
            <header className={styles.header}>
              <div className={clsx(styles.imgContainer, styles.brand)}>
                {
                  (true) ?
                 <img src={race_sportsbook_no_goblet} alt="Caesars Sportsbook" className={styles.img} />
                  :
                  <img src={hawthorne} alt="Hawthorne" className={styles.img} />
                }
              </div>
              <div className={styles.titleContainer}>
                <div className={clsx(styles.imgContainer, styles.ntra)}>
                  <img src={ntra} alt="National Thoroughbred Racing Association" className={styles.img} />
                </div>
                <div className={styles.subtitleContainer}>
                  {
                    leaderboardPresent ?
                    (
                      <span>
                        <h2 className={styles.subtitle}>{leaderboard.description}</h2>
                      </span>
                    )
                    : 
                    (
                        <span/>
                    )
                  }
                  
                </div>
                {
                  leaderboard.timestamp ? (
                    <span className={styles.timestamp}>last updated {dayjs
                      .duration(dayjs(leaderboard.timestamp).diff(dayjs()), 'milliseconds')
                      .humanize(true)} ({dayjs(leaderboard.timestamp).format('MM/DD/YYYY hh:mmA')})</span>
                  ) : null
                  }
              </div>
              <div className={clsx(styles.imgContainer, styles.tvg)}>
                <img src={caesars} alt="Caesars" className={styles.img} />
                {
                  (false) ? 
                  <img src={tvg} alt="TVG" className={styles.img} />
                  : 
                  <span/>
                }
              </div>
            </header>
            <div className={clsx(styles.leaderboard, users.length>0 && styles.leaderboardSplit)}>
              <ul className={styles.list}>
                {
                  leaders.map((leader) => (
                    <li key={leader.playerId}>
                      <LeaderItem user={leader} />
                    </li>
                  ))
                }
              </ul>
              {
                loading ? (
                  <div className={styles.loadingContainer}>
                    <img src={loadingGif} alt="Loading" />
                  </div>
                ) : (
                  (users.length > 0) ? (
                  <ul className={styles.list}>
                    {
                      users.map((user) => (
                        <li key={user.playerId}>
                          <UserItem user={user} />
                        </li>
                      ))
                    }
                  </ul>
                  ) : 
                  (
                    null
                  )
                )
              }
            </div>
          </div>
        ) : null
      }
    </div>
  );
}